import * as React from "react";
const SvgIcMarkdown = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.5 3.333V5H15v10h-2.5v1.667h4.167V3.333H12.5Zm-9.167 0v13.334H7.5V15H5V5h2.5V3.333H3.333Z" /></svg>;
export default SvgIcMarkdown;